import React, {useEffect} from 'react';
import {useLocation} from 'react-router-dom';

import image1Regular from 'presentation/assets/images/family1.webp';
import image1Large from 'presentation/assets/images/family1@2x.webp';
import image2Regular from 'presentation/assets/images/family2.webp';
import image2Large from 'presentation/assets/images/family2@2x.webp';
import image3Regular from 'presentation/assets/images/family3.webp';
import image3Large from 'presentation/assets/images/family3@2x.webp';
import {FirstAccessEnum, ForgotPasswordEnum, SignUpEnum} from 'presentation/constants';
import {StyledImg} from './styles';

function getImg(pathname: string) {
	if (pathname.includes(SignUpEnum.SIGN_UP) || pathname.includes(FirstAccessEnum.FIRST_ACCESS)) {
		return {
			regular: image3Regular,
			large: image3Large,
		};
	}
	if (pathname.includes(ForgotPasswordEnum.FORGOT_PASSWORD)) {
		return {
			regular: image2Regular,
			large: image2Large,
		};
	}
	return {
		regular: image1Regular,
		large: image1Large,
	};
}

export function DynamicImage() {
	const {pathname} = useLocation();

	useEffect(() => {
		getImg(pathname);
	}, [pathname]);

	return (
		<StyledImg
			src={getImg(pathname).regular}
			srcSet={`${getImg(pathname).regular} 1x, ${getImg(pathname).large} 2x`}
			alt="Família Feliz Reunida"
		/>
	);
}
